import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DescargarArchivo } from '../../../services/download.service'
import { CustomModalComponent } from './../../../Components/custom-modal/custom-modal.component';
import { PaginationActionsService } from '../../../Components/pagination-actions/pagination-actions.service';
import { Subscription } from 'rxjs';
import {FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { AreaService } from '../../../services/area.service';
import { PaginationActionsComponent } from '../../../Components/pagination-actions/pagination-actions.component';
import { debounceTime } from 'rxjs/operators';
import { PersonaAutocompleteComponent } from '../../../Components/persona-autocomplete/persona-autocomplete.component';
import { AreaAutocompleteComponent } from '../../../Components/area-autocomplete/area-autocomplete.component';
import { NavbarService } from '../../../Components/navbar/navbar.service';
import { PersonaAreaAutocompleteComponent } from '../../../Components/persona-area-autocomplete/persona-area-autocomplete.component';
import { PersonaService } from '../../../services/persona.service';


export interface Area {
    idArea: number;
    nombre: string;
    dependencia: number;
    idSede: number;
    idPersonaAa: number;
    idPersonaJa: number;
    nombreAsistente: string;
    nombreJefe: string;
    nombreDependencia: string;
}
export const trimNameValidator: ValidatorFn = (
    control: FormGroup
): ValidationErrors | null => {
    const nombre = control.get("nombre")
    const word = nombre.value + ''
    return nombre.value.trim() !==  ''
        ? null
        : { 'spaces': true }
}
@Component({
    selector: 'app-areas',
    templateUrl: './areas.component.html',
    styleUrls: ['./areas.component.scss']
})
export class AreasComponent implements OnInit, OnDestroy {

    @ViewChild('formModal') formModal: CustomModalComponent
    @ViewChild('enviarFirmaModal') enviarFirmaModal: CustomModalComponent
    @ViewChild('jefeAutocomplete') jefeAutocomplete: PersonaAreaAutocompleteComponent
    @ViewChild('asistenteAutocomplete') asistenteAutocomplete: PersonaAreaAutocompleteComponent
    @ViewChild('dependenciaAutocomplete') dependenciaAutocomplete: AreaAutocompleteComponent


    cargandoLista: boolean = false;
    cargandoDetalle: boolean = false;

    private paginationPage = 1;
    private paginationSize = 25;
    private paginationSizeSub: Subscription
    searchControl = new FormControl('')

    listaSede = []
    listData2 = []
    editando = false

    formArea = new FormGroup({
        idArea: new FormControl(),
        nombre: new FormControl('', [Validators.required]),
        // dependencia: new FormControl('', [Validators.required]),
        dependencia: new FormControl('', ),
        idSede: new FormControl('', [Validators.required]),
        idPersonaAa: new FormControl(),
        idPersonaJa: new FormControl(),
        nombreAsistente: new FormControl(),
        nombreJefe: new FormControl(),
        nombrePadreDependencia: new FormControl(),
    }, {validators: trimNameValidator})

    listData = {
        "pageNum": 0,
        "pageSize": 0,
        "size": 0,
        "startRow": 0,
        "endRow": 0,
        "total": 0,
        "pages": 0,
        "prePage": 0,
        "nextPage": 0,
        "isFirstPage": false,
        "isLastPage": false,
        "hasPreviousPage": false,
        "hasNextPage": false,
        "navigatePages": 8,
        "navigatepageNums": [],
        "navigateFirstPage": 0,
        "navigateLastPage": 0,
        "firstPage": 0,
        "lastPage": 0,
        "list": (<Area[]>[])
    }
    idArea: any;

    constructor(
        public descargas: DescargarArchivo,
        private areaService: AreaService,
        private paginationService: PaginationActionsService,
        private navbarService: NavbarService,
        private personaService: PersonaService
    ) { }

    @ViewChild('miPaginator') paginator: PaginationActionsComponent

    ngOnInit(): void {
        this.cargarListaArea('')
        this.navbarService.getBandejas().subscribe(res => {
            if (!res) {
                this.idArea = ''
                return
            };
           // this.idArea = res.selected.idArea + ''

        })

        this.paginationSizeSub = this.paginationService.watchSizeChange().subscribe(size => {
            this.listData.pageSize = size
            this.paginationSize = size
            this.cargarListaArea('')
        })
        this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.cargarListaArea(value)
        })

        this.areaService.getSedes().toPromise().then(res => {
            this.listaSede = res
        })
    }

    ngOnDestroy(): void {
        this.paginationSizeSub.unsubscribe()
    }

    cargarListaArea(value?: string) {
        if (value) {
            this.paginationPage = 1
        }
        this.cargandoLista = true
        this.listData.list = []
        this.areaService.listarArea({ size: this.paginationSize.toString(), page: this.paginationPage.toString(), nombre: value })
            .then((res: any) => {
                this.listData = res
                this.cargandoLista = false
            })
    }

    previusPage() {
        if (!this.listData.hasPreviousPage) return
        this.paginationPage--
        this.cargarListaArea('')
    }

    nextPage() {
        if (!this.listData.hasNextPage) return
        this.paginationPage++
        this.cargarListaArea('')
    }
    
    Dependencia: string;
    Jefe: string;
    Asistente: string;

    showForm(registro?: Area) {
        this.formModal.open()
        this.clearForm()

        if (registro) {
            this.idArea = registro.idArea;
            this.loadArea(registro.idArea)

            this.jefeAutocomplete.idArea = this.idArea
            this.jefeAutocomplete.findData()

            this.asistenteAutocomplete.idArea = this.idArea
            this.asistenteAutocomplete.findData()

            this.formArea.get('idPersonaAa').setValidators(Validators.required)
            this.formArea.get('idPersonaJa').setValidators(Validators.required)
            this.formArea.get('idPersonaAa').updateValueAndValidity()
            this.formArea.get('idPersonaJa').updateValueAndValidity()
            this.editando = true
        }
        else {
            this.editando = false
        }
    }

    clearForm() {
        Object.keys(this.formArea.controls).forEach(key => {
            this.formArea.get(key).setValue('')
        })
    }

    async loadArea(id) {
       
        this.cargandoDetalle = true

        const res: any = await this.areaService.detalleArea({ idArea: id })
        console.log(res);
        Object.keys(this.formArea.controls).forEach(key => {
            this.formArea.get(key).setValue(res[key])
        })

        this.jefeAutocomplete.inputControl.setValue(res.nombreJefe)
        this.asistenteAutocomplete.inputControl.setValue(res.nombreAsistente)
        this.dependenciaAutocomplete.inputControl.setValue(res.nombreDependencia)
        //this.idArea = res.idArea;

        this.cargandoDetalle = false
    }

    async guardarArea() {
        if (this.formArea.invalid) {return}
        if (this.searchControl.value.length > 0) {
            this.searchControl.setValue('');
        }
        this.cargandoDetalle = true
        if (this.formArea.get('idArea').value == '') {
            await this.areaService.CrearArea({
                'nombre': this.formArea.controls.nombre.value,
                'dependencia': this.formArea.controls.dependencia.value,
                'idSede': this.formArea.controls.idSede.value
            })
        } else {

            await this.areaService.actualizar({
                'idArea': this.formArea.controls.idArea.value,
                "nombre": this.formArea.controls.nombre.value,
                "dependencia": this.formArea.controls.dependencia.value,
                "idSede": this.formArea.controls.idSede.value,
                "idPersonaAa": this.formArea.controls.idPersonaAa.value,
                "idPersonaJa": this.formArea.controls.idPersonaJa.value,
            })
        }

        this.formModal.close()
        this.cargandoDetalle = false
        this.cargarListaArea('')
    }

    DataJefe(event) {
        this.formArea.get('idPersonaJa').setValue(event.idPersona)

    }
    async CrearArea() {

        this.cargandoDetalle = true

        await this.areaService.CrearArea(this.formArea.value)

        this.formModal.close()
        this.cargandoDetalle = false
        this.cargarListaArea('')
    }


    async eliminar(id) {
        if (confirm('Seguro que desea eliminar')) {
            await this.areaService.EliminarArea({ idArea: id })
            this.formModal.close()
            this.cargarListaArea('')

        }
    }
    setAsistente(event) {
        this.formArea.get('idPersonaAa').setValue(event.idPersona)
    }

    get idAreaControl() {
        return this.formArea.get('idArea') as FormControl;
    }
    get nombreControl() {
        return this.formArea.get('nombre') as FormControl;
    }
    get dependenciaControl() {
        return this.formArea.get('dependencia') as FormControl;
    }
    get idSedeControl() {
        return this.formArea.get('idSede') as FormControl;
    }
    get idPersonaAaControl() {
        return this.formArea.get('idPersonaAa') as FormControl;
    }
    get idPersonaJaControl() {
        return this.formArea.get('idPersonaJa') as FormControl;
    }
    get nombreAsistenteControl() {
        return this.formArea.get('nombreAsistente') as FormControl;
    }
    get nombreJefeControl() {
        return this.formArea.get('nombreJefe') as FormControl;
    }
    get nombrePadreDependenciaControl() {
        return this.formArea.get('nombrePadreDependencia') as FormControl;
    }
}
